export default {
    nav: {
        누르기:'даралт',
        메인:'гол',
        도메인: 'домэйн',
        아이디: 'нэвтрэх нэр',
        비밀번호: 'нууц үг',
        비밀확인:'нууц шалгалт',
        로그인: 'логин',
        공지사항:'мэдээлэл',
        변동정보:'өөрчлөлтийн мэдээлэл',
        이벤트:'эвэнт',
        회원관리:'гишүүдийн зохицуулалт',
        부본사관리:'дэд админы зохицуулалт',
        본사관리:'төв оффисын удирдлага',
        마스터관리:'мастер удирдлага',
        대시보드:'хяналтын самбар',
        총판관리:'төлөөлөгч зохицуулалт',
        게임관리:'тоглоомын менежмент',
        알본관리:'пойнт зогицуулалт',
        회원별입출금:'гишүүн бүрийн орлого зарлага',
        총판별입출금:'төлөөлөгч бүрийн орлого зарлага',
        RACE결과:'RACE үр дүн',
        구매내역RACE:'худалдан авалтын түүх(RACE)',
        RACE리스트:'RACE лист',
        입출금내역:'орлого зарлагын түүх',
        수동충환내역:'механик цэнэг, таталтын түүх',
        손실금RACE:'алдагдал(RACE)',
        머니로그:'money log',
        정산관리:'тооцооын зохицуулалт',
        출석체크:'ирц бүртгэл',
        고객센터:'үйлчилгээний төв',
        쪽지관리:'захианы зохицуулалт',
        게시판:'зарын самбар',
        팝업관리:'popup manage',
        답변관리:'хариулт зохицуулалт',
        접속리스트:'online',
        접속로그:'Хандалтын бүртгэл',
        배팅내역:'бооцооны түүх',
        배팅:'мөрий',
        계좌:'данс',
        종합로그:'нийт log',
        사이트설정:'site settings',
        구매내역파워볼:'худалдан авалтын түүх (powerball)',
        구매내역4조합:'худалдан авалтын түүх(4багц)',
        매장관리:'салбарын зохицуулалт',
        파워볼결과:'powerball үр дүн',
        사다리결과:'шат үр дүн',
        파워볼결과보글:'powerball үр дүн (boggle)',
        사다리결과보글:'шат үр дүн (boggle)',
        API배팅:'APIбооцоо',
        루징정산:'loosing тооцоо',
        팝업관리:'popup manage',
        일자별롤링루징:'өдөр бүрийн rolling & loosing',
        알잔액:'бонусны үлдэгдэл',
        입금내역:'орлогын хуулга',
        출금내역:'зарлагын хуулга',  
        배팅금액:'бооцооны хэмжээ',
        당첨금액:'хожлын хэмжээ',
        낙첨금액:'хожлын хэмжээ',
        배팅롤링:'сарьсан багваахай өнхрөх',
        정산비율:'Төлбөрийн хувь',
        루징금:'нэмэлт төлбөр',
        루징금카:'Олз (машин)',
        루징금슬:'Олз (өвдөг)',
        처리롤링금:'боловсруулсан гулсмал алт',
        보글롤링:'догдолж байна',
        카:'карт',
        슬:'гунигтай',
        파:'ногоон сонгино',
        배팅한도:'бооцооны хязгаар',
        딜레이:'саатал',
        적중한도:'хязгаарыг цохих',
        마지막출금:'сүүлчийн татан авалт',
        게임사:'тоглоомын компани',
        단:'зөвхөн',
        조:'нийтлэл',
        삭제관리:'Менежментийг устгах',
        죽장관리:'хулсны жанжин менежмент',
    },
    msg: {
      하부포함:'Доод хэсгийг оруулаад',
         손익:'орлого ба зарлага',
          죽장:'Жукжанг',
           최종손익:'эцсийн ашиг, алдагдал',
        테스트:'тест',
         본사롤링:'Төв оффис эргэлдэж байна',
          마스터롤링:'мастер өнхрөх',
        일:'Өдөр',
        조:'нийтлэл',
        최근접속:'Хамгийн сүүлд хандсан',
        알금액:'Өндөгний хэмжээ',
        억알:'100 сая эм',
        천만알f:'50 сая эм',
        천만알t:'30 сая эм',
        천만알w:'20 сая эм',
        천만알o:'10 сая эм',
        전체파싱:'Бүрэн задлан шинжлэх',
        전체정품:'Бүрэн жинхэнэ бүтээгдэхүүн',
        개별파싱:'Хувь хүний задлан шинжилгээ',
        인증요청:'Баталгаажуулах хүсэлт',
        접속중:'Холбож байна',
        인증취소차단:'Баталгаажуулалтыг цуцлах/блоклох',
        단계별회원:'Түвшингээр гишүүнчлэл',
        추천인내역:'곽누리 입완입니다',
        알충:'Өндөгний хальс',
        알환:'Алхван',
        카루징:'дурлах',
        파루징:'Парус хийх',
        루징내역:'Түүхийг алдах',
        정검:'Жонгём',
        총정산금:'Төлбөрийн нийт дүн',
        정산금카:'Суурин Геумка',
        정산금슬:'Jeongsan Geumseul',
        정산금파:'Жонсан Геумпа',
        롤링잔액:'eventm',
        공베팅:'хоосон бооцоо',
        카지노슬롯:'CASINO-SLOT',
        확인하시겠습니까:'Та баталгаажуулахыг хүсч байна уу?',
        취소하시겠습니까:'Та цуцлахдаа итгэлтэй байна уу??',
        처리중하시겠습니까:'Та боловсруулмаар байна уу?',
        언어전환:'хэл солих',
        아이디닉네임:'ID (хоч)',
        추천내역:'Зөвлөмж',
        배팅파워:'бооцоо (хүч)',
        머니합계:'Нийт мөнгө',
        이벤합계:'үйл явдлын нийлбэр',
        바루징:'хөөрөх',
        알충전:'цэнэглэ',
        알환전:'мөнгө татах',
        알차액:'ялгаа',
        알잔액:'тэнцвэр',
        머니이동차단:'Мөнгөний хөдөлгөөнийг хаах',
        파싱:'фартинг',
        슬롤링:'эргэлдэж байна',
        파롤링:'өршөөлөөс чөлөөлөх',
        카롤링:'каролинг',
        수동충전:'гараар цэнэглэх',
        슬루징:'эргүүлэх',
        수동환전:'гар аргаар валют солилцох',
        입금출금:'Хадгаламж - Татан авалт',
        문의:"1:1 асуулга",
        금일총입금:'өнөөдрийн нийт хадгаламж',
        금일총출금:'Өнөөдөр нийт татан авалт',
        데이타삭제:'Өгөгдлийг устгах',
        DATA리셋:'ӨГӨГДЛИЙГ дахин тохируулах',
        롤링금:'гулсмал алт',
        롤링금카:'Өнхрөх алт (машин)',
        롤링금슬:'Өнхрөх алт (өвдөг)',
        롤링금파단:'Rolling Gold (Far-Dan)',
        롤링금파조:'Өнхрөх алт (пар-жо)',
        문의제목:'Лавлагааны сэдэв',
        문의내용:'Лавлагаа',
        문의시간:'Лавлах хугацаа',
        적:'дайсан',
        낙:'таашаал',
        전환:'change',
        적중:'цохих',
        상세보기:'Дэлгэрэнгүй мэдээллийг харах',
        상세:'Дэлгэрэнгүй',
        상태:'status',
        일시:'огноо',
        잔고:'тэнцвэр',
        일륜:'нэг дугуй',
        일정:'хуанли',
        일경:'өдрийн үзэмж',
        한경:'Хан Кён',
        일반:'Ердийн',
        신규:'шинэ',
        한국경마:'Солонгосын морин уралдаан',
        한경삼복:'Хан Кён Самбок',
        한경쌍승:'Han Kyung Ssangseung',
        한경복연:'Хан Кён Бокён',
        일본경정:'Японы засгийн газар',
        경정삼복:'Кёнжон самбок',
        일본경륜:'Японы дугуйн уралдаан',
        경륜삼복:'унадаг дугуй гурван дугуй',
        일본경마:'Японы морин уралдаан',
        일경삼복:'нэг гён гурван хувцас',
        일경삼쌍:'гурван хос',
        비번:'үүргээс чөлөөлөх',
        숨김:'нуугдаж байна',
        레벨선택:'түвшний сонголт',
        오늘접속:'өнөөдөр холбогдоно уу',
        본사요역:'төв оффисын станц',
        아이디를입력하세요: 'нэвтрэх нэр оруулна уу',
        비밀번호를입력하세요: 'нууц дугаар оруулга уу',
        도메인을입력하세요: 'домэйн оруулна уу',
        성공적로그인:'амжилттай нэвтэрлээ',
        블랙:'хар',
        대기:'хүлээ',
        기본:'үндсэн',
        제목입력:'Гарчиг оруулна уу',
        받은쪽지함:'ирсэн хайрцаг',
        내용:'Агуулга',
        유효기간:'дуусах хугацаа',
        답변내용:'Хариултын агуулга',
        답변시간:'хариу цаг',
        처리중:'шийдэж байна',
        완료:'шийдэгдсэн',
        보류:'түтгэлзэх',
        유저:'хэрэглэгч',
        답변:'хариулах',
        수정완료:'өөрчлөлт дууслаа',
        마지막로그인:'сүүлчийн нэвтрэлт',
        마지막입금:'сүүлчийн хадгаламж',
        IP차단:'IP блоклох',
        비번수정:'үүргээс чөлөөлөх',
        로그아웃:'Гарах',
        아이디:'нэвтрэх нэр',
        닉네임:'nickname',
        입금인:'орлогодсон хүн',
        예금주:'данс эзэмшигч',
        핸드폰:'гар утас',  
        입금금액:'Хадгаламжийн хэмжээ',
        확인시간:'баталгаажуулах хугацаа',
        팅기기:'Тинггиги',
         매장:'салбар',
        가입IP:'Захиалгын IP',
        최종IP:'эцсийн IP',
        알본:'пойнт',
        쪽지:'Анхаарна уу',
        가입시:'бүртгүүлэх үед',
        아웃:'гарч',
        입금시:'орлогодох үед',
        로그인전머니:'мөнгө оруулах',
        로그인회수:'нэвтрэх тоо',
        로그아웃처리:'гарах боловсруулалт',
        정검:'сэлэм',
        모든회원이보유한카슬머니파워머니합계입니다:'Энэ нь бүх гишүүдийн эзэмшиж буй Castle Money + Power Money-ийн нийт дүн юм.',
        삭제하시겠습니까:'устгах уу?',
        수정하시겠습니까:'өөрчлөх үү?',
        리턴하시겠습니까:'буцах уу?',
        아웃하시겠습니까:'гарахдаа итгэлтэй байна уу?',
        본사가보유한카슬머니잔액입니다:'Энэ бол төв оффисын эзэмшиж буй Castle Money үлдэгдэл юм.',
        게임사확인가능:'Тоглоомын компанийн баталгаажуулалт',
        최소배팅:'Хамгийн бага бооцоо',
        최대배팅:'хамгийн их бооцоо',
        회차당토탈최대배팅:'Нэг тойрогт нийт бооцоо',
        리턴:'буцах',
        입력해주세요:'оруулна уу',
        수정:'өөрчлөх',
        리셋:'ресет',
        취소됨:'цуцлагдсан',
        알림:'анхаауулга',
        입금:'орлого',
        베팅당첨롤링슬:'Бооцоо тавих/хожих/өнхрөх (өвдөг)',
        베팅당첨롤링카:'Бооцоо тавих/хожих/өнхрөх (машин)',
        베팅당첨롤링파:'Бооцоо тавих/хожих/өнхрөх (нэмэх)',
        출금:'зарлага',
        카슬:'Машин% / Өвдөг%',
        출금금액:'Татан авалтын хэмжээ', 
        삭제:'устгах',
        레이스배팅:'RACE бооцоо',
        파워볼배팅:'powerball бооцоо',
        취소:'cancel',
        이벤트전환:'эвэнтийн мэдээлэл',
        이벤트지급:'эвэнт олголт',
        롤링전환:'loosing мэдээлэл',
        롤링지급:'loosing олголт',
        매장롤링:'салбар rolling',
        총판롤링:'төлөөлөгч rolling',
        부본사롤링:'дэд админ rolling',
        회원롤링:'гишүүн rolling',
        알충전:'пойнт цэнэглэлт',
        알환전:'пойнт таталт',
        롤링충전:'rolling цэнэглэлт',
        롤링환전:'rolling таталт',
        업로드완료:'upload complete',
        업로드:'байршуулах',
        입출금:'орлого зарлага',
        대중소:'том дунд Жижиг',
        사이트머니카지노머니전환:'site money->casino money мэдээлэл',
        카지노머니:'казиногийн мөнгө',
        카지노머니사이트머니전환:'casino money->site money мэдээлэл',
        검색타이틀선택하세요:'хайх зүйлээ сонгоно уу',
        환불하시겠습니까:'буцаалт хийх үү?',
        사이트머니:'site money',
        카지노슬롯머니:'casino slot money',
        사용안함:'хэрэглэхгүй',
        사용:'хэрэглэх',
        탈퇴:'гарах',  
        파홀짝:'балга',
        일홀짝:'балга',
        파언오:'Фаеон Өө',
        일언오:'нэг үг өө',
        제목:'гарчиг',
        마스터요역:'Мастер Ё станц',
        답변제목:'Хариултын гарчиг',
        전체:'бүгд',
        금지:'хариглоно',
        보글:'boggle',
        경기전:'тэмцээний өмнө',
        하위포함:'дэд багтсан',
        비적중:'мисс',
        없음:'байхгүй',
        본사없음:'본사없음',
        마스터없음:'마스터없음',
        구매자:'худалдан авагч',
        파워볼:'powerball',
        등록:'бүртгэл',
        일반볼조합:'энгийн ball холимог',
        파워볼조합:'powerball холимог',
        파워일반조합:'энгийн powerball холимог',
        카슬파루징:'Машин + өвдөг + пароз',
        적특:'Онцгой',
        모든조합:'бүх холимог',
        사다리:'шат',
        동행:'дагалдан явах',
        회차:'round',
        총판:'төлөөлөгч',
        부본사:'дэд админ',
        부본:'түнш',
        전금액:'бүрэн хэмжээний',
        실패:'бүтэлгүйтэл',적중:'оновчтой',
        배팅:'бооцоо',
        당첨:'тохирол',
        베팅당첨:'бооцоо тавих - ялах',
        보유머니:'мөнгө барьж байна',
        보유이벤트:'арга хэмжээ зохион байгуулж байна',
        마스터생성:'мастер бүтээл',
        환불:'буцаалт',
        슬롯:'slot',
        라이브:'live',
        확인:'ok',
        정상:'хэвийн',
        차단:'блок',
        추천인:'зөвлөгч',
        카지노죽장:'카지노죽장',
        슬롯죽장:'슬롯죽장',
        배당:'хуваарилалт',
        베팅:'мөрий',
        사일:'4 хоног',
        사조:'сажо',
        팝업:'pop-up',
        내역이1000건이넘습니다1000건아래로검색하신후다운로드해주세요:'илэрц 1000с илүү байна.1000 дотор хайгаад татаж авна уу',
        오늘배팅내역만다운가능합니다:'өнөөдөр зөвхөн бооцооны түүх л татах боломжтой байна!!!',
        리셋하시겠습니까:'리셋하시겠습니까?',
        엑셀저장완료:'excelfile татаж дууслаа',
        크기보다작아야함:'2MBс бага байх хэрэгтэй',
        충전:'цэнэглэлт',
        환전:'таталт',
        가능:'боломжтой',
        게임머니:'game money',
        갱신완료:'шинэчлэлт дууссан',
        이벤트머니:'event money',
        이전롤링:'Өмнөх Rolling',
        바치기:'хандивлах%',
        롤링머니:'rolling money',
        배팅누적:'бооцооны хуримтлал',
        합계:'нийт дүн:',
        지급:'олголт',
        카지노:'casino',
        하부아이디:'нэвтрэх нэр',
        총판또는매장선택해주세요:'төлөөлөгч эсвэл салбар сонгоно уу',
        회원:'гишүүн',
        조합:'Хослол',
        파트너:'хамтрагч',
        신청시ip:'хүсэлт гаргасан ip',
        삭제하시겠습니까복구불가:'устгах уу?буцаах боломжгүй!',
        적용하시겠습니까:'тохируулах уу?!',
        등록하시겠습니까:'элсэх үү?',
        입금보너스:'цэнэглэлтийн бонус',
        일반조합:'энгийн холимог-',
        파워조합:'powerball холимог-',
        파워:'Хүч',
        적용:'тохируулах',
        비번이일치하지않습니다:'нууц дугаар буруу байна',
        지원안됩니다:'тохирохгүй байна', 
        로그인팝업:'нэвтрэх цонх',
        파워머니충전:'Эрчим хүчний мөнгө цэнэглэх',
        파워머니환전:'эрчим хүчний мөнгөний солилцоо',
        파워롤링충전:'Эрчим хүчний эргэлтийн цэнэг',
        파워롤링환전:'Эрчим хүчний эргэлтийн солилцоо',
        일반회원을매장으로조정입니다:'Дэлгүүрт ерөнхий гишүүдийн тохируулга.',
        회원아이디:'Гишүүн ID',
        날자:'нисье',
        닫기:'хаах',
        보글파조합:'Боглийн долгионы хослол',
        사이트머니:'сайтын мөнгө',
        카지노슬롯머니:'казиногийн тоглоомын мөнгө',
        에서:'цагт',
        전환하기:'солих',
        카:'карт',
        슬:'гунигтай',
        시0:'00хот',
        시1:'01хот',
        시2:'02хот',
        시3:'03хот',
        시4:'04хот',
        시5:'05хот',
        시6:'06хот',
        시7:'07хот',
        시8:'08хот',
        시9:'09хот',
        시10:'10хот',
        시11:'11хот',
        시12:'12хот',
        시13:'13хот',
        시14:'14хот',
        시15:'15хот',
        시16:'16хот',
        시17:'17хот',
        시18:'18хот',
        시19:'19хот',
        시20:'20хот',
        시21:'21хот',
        시22:'22хот',
        시23:'23хот',
        롤링합계:'гулсмал нийт',
        배팅당첨:'бооцоо тавих - ялах',
        슬당첨:'ялна',
        파배팅:'алгадах',
        슬배팅:'алгадах бооцоо',
        카당첨:'карт хож',
        파당첨:'сугалаа',
        카배팅:'карбатжуулах',
        모든회원이보유한카슬롤링파워롤링합계입니다:'Энэ нь бүх гишүүдийн Castle Rolling + Power Rolling-ийн нийлбэр юм.',
        총판출금:'нийт борлуулалт',
        배팅차단:'бооцооны блок',
        파사롤링:'Pasa Rolling',
        롤링파단:'Rolling (Far-Dan)',
        롤링파조:'Rolling (Far-Joe)',
        가입시코드:'Бүртгүүлэх үед код',
        롤링:'өнхрөх',
        롤링카:'Өнхрөх (машин)',
        롤링슬:'өнхрөх (өвдөг)',
        롤링파:'Өнхрөх (ногоон)',
        하부롤링:'доод өнхрөх',
        실지급금:'бодит төлбөр',
        루징:'алдаж байна',
        수익:'орлого',
        총롤링:'буу эргэлдэж байна',
        총:'буу',
        포인트롤링:'Цэг (өнхрөх)',
        카슬머니:'Castle Mone',
        카슬머니갱신:'Castle Money Renewal',
        카슬롤링:'castrolling',
        파워머니:'хүчний мөнгө',
        파워롤링:'цахилгаан гулсмал',
        접속자:'нэмэлт хэрэгсэл',
        입금액:'хадгаламжийн хэмжээ',
        총입금:'нийт хадгаламж',
        출금액:"Татан авалтын хэмжээ",
        총출금:'нийт татан авалт',
        파워볼일반:'ерөнхий хүчний бөмбөг',
        파워볼조합:'цахилгаан бөмбөгний хослол',
        보글파일반:'Богле овоолгын анги',
        보글사일반:'Boggle Sage',
        보글사조합:'Боглын холбоо',
        바카라롤링:'баккара гулсмал',
        슬롯롤링:'оролт гулсмал',
        바카라루징:'баккара',
        슬롯루징:'үүр алдах',
        가입시간:'бүртгүүлэх хугацаа',
        파워볼일반보글:'Powerball General (Vogle)',
        파워볼조합보글:'Пауэрболын хослол (Богле)',
        사다리일반보글:'Энгийн шат (Бобгл)',
        사다리조합보글:'Шатны хослол (Бобгл)',
        충환:'Чун-Хван',
        총배팅:'нийт бооцоо',
        총배팅카:'Нийт бооцоо (машин)',
        총배팅슬:'Нийт бооцоо (өвдөг)',
        총배팅파:'Нийт бооцоо (нэр)',
        총당첨:'нийт ялалт',
        총당첨카:'Нийт ялалт (K)',
        총당첨슬:'Нийт ялалт (S)',
        총당첨파:'Нийт ялалт (нэр)',
        총수수료:'нийт хураамж',
        총수수료카:'Нийт хураамж (К)',
        총수수료슬:'Нийт хураамж (S)',
        총수수료파:'Нийт хураамж (нэр)',
        총수익:'нийт ашиг',
        총수익카:'Нийт орлого (машин)',
        총수익슬:'Нийт ашиг(ууд)',
        총수익파:'нийт ашиг',
        등급:'Үнэлгээ:',
        상위:'ялгаа:',
        접속:'холбох',
        가입코드:'бүртгүүлэх код',
        본사:'төв оффис',
        가입경로:'захиалгын зам',
        가입일:'Түүнээс хойш гишүүн',
        레밸:'түвшин',
        아이디만입력시해당아이디로만전송:'Зөвхөн ID оруулах үед зөвхөн ID илгээгдэнэ.',
        아이디입력및부본총판매장선택시해당소속회원까지전송:'ID-г оруулаад хоёрдогч борлуулагчийг сонгохдоо гишүүн рүү илгээдэг',
        아이디없이레벨만선택시해당등급에만전송:'Хэрэв та ID-гүй зөвхөн түвшинг сонговол зөвхөн тухайн түвшинд илгээгдэнэ',
        레벨:'түвшин',
        마스터:'мастер',
        본:'хуулбарлах',
        가입:'нэгдэх',
        조바:'Жоба',
        단바:'Данба',
    },
    status:{
        편집:'засварлах',
        선택:'сонгох',
        알본선택:'Албон сонголт',
    },
    dateText:{
        최근한주:'ойрын 7 хоног',
        최근한달:'ойрын нэг сар',
        최근3개월:'ойрын 3 сар',  
    },
    title:{
        소속회원:'хамааралтай гишүүн',
        소속총판:'хамааралтай төлөөлөгч',
        회원리스트:'гишүүдийн лист',
        소속부본:'холбоотой хуулбар',
        소속본사:'харьяа төв байр',
    },
    searchText:{
        선택레벨수정:'Edit Level',
       로그인오류:'로그인오류',
        선택승인:'Зөвшөөрөл',
        죽장정산:'Жукжан Жонсан',
        매장생성:'дэлгүүр бий болгох',
        회원매장업:'Гишүүн->Дэлгүүрийн бизнес',
        인증코드:'баталгаажуулах код',
        단폴:'Данполь',
        요율:'요율',
        선택환불:'Нэмэлт буцаан олголт',
        카슬충전:'Castle Charge',
        카슬환전:'Castle валютын солилцоо',
        카슬차액:'цайзын ялгаа',
        파워충전:'цахилгаан цэнэглэх',
        파워환전:'эрчим хүчний солилцоо',
        파워차액:'хүчний ялгаа',
        알충:'шавьж',
        알환:'эм',
        카슬:'Цайз',
        보낸쪽지함:'Ирсэн имэйл хайрцаг',
        매장선택:'дэлгүүрийн сонголт',
        회원생성:'гишүүн бий болгох',
        머니충환전:'мөнгө солилцох',
        노출:'халдвар авах',
        게임수량:'тоглоомын тоо',
        부본사생성:'хоёрдогч штаб байгуулах',
        부징금층배팅금당침금배팅롤링손해금루징:'Торгууль = (Давхар бооцоо - Өр - Өнхрөх - Алдагдал) * Алдагдал %',
        구글OTP:'Google OTP',
        접속회원수:'Холбогдсон гишүүдийн тоо',
        선택삭제:'Сонголтыг устгах',
        쪽지보내기:'надад тэмдэглэл илгээ',
        타이틀선택:'Гарчиг сонголт',
        엑셀다운:'унасан',
        키워드:'түлхүүр үг',
        시작:'эхлэх',
        마감:'эцсийн хугацаа',
        검색:'Хайх',
        입금계:'хадгаламжийн данс',
        출금계:'кассчин',
        차액:'ялгаа',
        알본생성:'Альбон үүсэх',
        리스트에노출될키워드:'Жагсаалтад харуулах түлхүүр үгс',
        구분:'хэлтэс',
        상태선택:'муж улсын сонголт',
        구매시간:'худалдан авах хугацаа',
        카지노잔액:'казиногийн үлдэгдэл',
        날자선택:'огнооны сонголт',
        페이지:'Хуудас',
        불러오기:'ачаалж байна',
        시간선택:'цаг сонголт',
        롤링처리:'өнхрөх боловсруулалт',
        타입선택:'төрлийн сонголт',
        본사생성:'төв оффис байгуулах',
        jackpot금액:'Jackpot хэмжээ:',
        주간출금랭킹Top1ID:'Долоо хоног бүр мөнгө татах шилдэг 1 ID:',
        주간출금랭킹Top1머니:'Долоо хоног бүр мөнгө татах шилдэг 1 мөнгө:',
        바카라점검:'баккара шалгах:',
        슬롯점검:'Слот шалгах:',
        원:'нэг',
        분:'минут',
        서비스:'үйлчилгээ',
        점검중:'хяналтанд байна',
        서비스점검:'үйлчилгээний үзлэг:',
        점검중멘트:'Шалгалтын тайлбар:',
        관리자접속가능아이피:'Админд хандах боломжтой IP:',
        환전최소금액:'Валютын солилцооны доод хэмжээ:',
        회최대환전금액:'Нэг удаагийн солилцооны дээд хэмжээ:',
        일최대환전금액:'Өдрийн дээд ханш:',
        재환전신청가능시간:'Дахин солилцох хүсэлт гаргах цаг болжээ:',
        은행계좌:'банкны данс:',
        필수아님:"шаардлагагүй",
        입력필수:'оруулах шаардлагатай',
        회원가입시추천인:'Гишүүнчлэлд бүртгүүлэх үед санал болгож байна:',
        회원한줄광고:'гишүүн шугамын сурталчилгаа:',
        총판한줄공지:'нэг мөр мэдэгдэл:',
        가입쪽지제목설정:'Захиалгын мессежийн гарчгийн тохиргоо:',
        가입쪽지문구설정:'Бүртгүүлэх мессежийн текстийг тохируулна уу:',
        고객센터가상계좌:'Хэрэглэгчийн төв-Виртуал данс:',
        고객센터온라인계좌:'Хэрэглэгчийн төв-Онлайн данс:',
        고객센터지인계좌:'Хэрэглэгчийн төв-Танилын данс:',
        고객센터요청처리완료:'Хэрэглэгчийн төв - Хүсэлтийг боловсруулж дууслаа:',
        고객센터대기멘트:'Хэрэглэгчийн төв-Хүлээж буй сэтгэгдлүүд:',
        고객센터여신불가:'Хэрэглэгчийн төв - Зээл байхгүй:',
        고객센터서비스불가:'Хэрэглэгчийн төв - Үйлчилгээ байхгүй:',
        고객센터환전지연:'Хэрэглэгчийн төв - Валютын солилцооны саатал:',
        고객센터인터넷불량:'Хэрэглэгчийн төв - Интернет муу:',
        저장:'хадгалах',
        요청:'хүсэлт',
        상위노출:'상위노출',    
    },
    tableText:{
      내손익:'миний ашиг, алдагдал',
      쪽지:'Анхаарна уу',
      최종로그인:'Эцсийн нэвтрэлт',
        총판아이디:'Дистрибьюторын ID',
        충환ID:'AC-ID',
        현카슬:'Хён цайз',
        현롤링:'утас өнхрөх',
        현제비번:'Одоогын Нууц Үг',
        차단하기:'IP차단',
        원인:'шалтгаан',
        IP해재:'IP해재',
        총판이름:'Дистрибьюторын нэр',
        총판생성:'Дистрибьютер бий болгох',
        매장이름:'дэлгүүрийн нэр',
        처리상태:'боловсруулах байдал',
        보낸사람:'Илгээгч',
        합:'синтез',
        구매내역:'Худалдан авалтын түүх',
        바카라배팅당첨:'Баккара (Бооцоо тавих)',
        총판입금:"нийт хадгаламж",
        관리자입금:'Менежерийн хадгаламж',
        관리자출금:'Менежерийг татан буулгах',
        계좌정보:'Дансны мэдээлэл',
        완료시간:'Дуусгах хугацаа',
        이전이벤트머니:'Өмнөх арга хэмжээний мөнгө',
        이전게임머니:'өмнөх тоглоомын мөнгө',
        변동후:'өөрчлөгдсөний дараа',
        배팅카슬:'бооцоо (цайз)',
        알충환:'Чунхван ал',
        베팅롤링:"бооцоо тавих",
        변동후롤링:'Хэлбэлзлийн дараа өнхрөх',
        전용가상:'зориулагдсан виртуал',
        추천:'санал',
        주소:'хаяг',
        변동후머니:'хувьсах мөнгө',
        보낸내용:'Агуулга илгээсэн',
        보낸시간:'зарцуулсан цаг',
        읽은시간:'унших цаг',
        마스터아이디:'Мастер ID',
        슷자:'явцгаая',
        마스터이름:'мастер нэр',
        부본사총판매장:'Төвийн орлогч - Дистрибьютор - Дэлгүүр',
        이미지수정:'зураг засварлах',
        게임아이디:'тоглоомын ID',
        로고:'лого',
        점검:'үзлэг',
        영어타이틀:'Англи гарчиг',
        한글이름:'Солонгос нэр',
        순위:'зэрэглэл',
        하위총판:'дэд дистрибьютер',
        부본사아이디:'Дэд штабын үнэмлэх',
        부본사요역:'Бубонсайо станц',
        데이타가없습니다:'Өгөгдөл алга',
        이름:'нэр',
        브라우저:'хөтөч',
        도메인:'домэйн',
        시간:'цаг',
        잔액:'тэнцвэр',
        머니변동:'мөнгөний өөрчлөлт',
        롤링변동:'rolling өөрчлөлт',
        베팅당첨:'betwin',
        아이피:'IP',
        변동금액:'хувьсах хэмжээ',
        현잔액:'одоогийн тэнцвэр',
        내역:'түүх',
        적중금:'цохих',
        신청시잔액:'Өргөдөл гаргах үеийн үлдэгдэл',
        오늘입금:'Өнөөдөр хадгаламж',
        신청시간:'Өргөдөл гаргах хугацаа',
        사용자암호:'хэрэглэгчийн нууц үг',
        알본사선택:'Албон компанийн сонголт',
        본사선택:'Төв оффисын сонголт',
        부본사선택:'Төвийн орлогчийг сонгох',
        상위부본선택:'Дээд хуулбарыг сонгоно уу',
        부본사이름:'Дэд оффисын нэр',
        마스터선택:'Мастер сонголт',
        api매장ID:'api дэлгүүрийн ID',
        api매장PW:'api дэлгүүр PW',
        하위회원:'дэд гишүүн',
        보유알:'өндөг барих',
        충환전:'төлбөр солилцох',
        연락처:'Холбоо барих',
        하위본사:'дэд төв байр',
        총판선택:'Дистрибьютерийн сонголт',
        상태:'нөхцөл байдал',
        수정:'залруулга',
        추가:'Нэмэх',
        부본사총판추천인:'Төвийн орлогч/Дистрибьютер/Зөвлөмж',
        출금비번:'Татгалзах нууц үг',
        회수가능:'нөхөн сэргээх боломжтой',
        은행명:'банкны нэр',
        계좌번호:'Дансны дугаар',
        예금주:'Данс эзэмшигч',
        회도메인:'нийгмийн домэйн',
        은행이름:'банкны нэр',
        파도메인:'Падмейн',
        타입:'төрөл',
        금액:'хэмжээ',
        처리시간:'Боловсруулах цаг',
        메모:'тэмдэглэл',
        만원:'Арван мянган вон',
        정정:'залруулга',
        알본사:'Альбонса',
        위치:'байршил',
        추가시간:'нэмэлт цаг',
        유효기간:'дуусах хугацаа',
        사용업체:'Хэрэглэгч компани',
        부본사총판매장:'Төвийн орлогч/Дистрибьютер/Дэлгүүр',
        게임:'тоглоом',
        날짜:'огноо',
        슬롯배팅:'слот бооцоо',
        슬롯당첨:'Слот хожих',
        슬롯배팅당첨:'Slots (бооцоо хожих',
        포인트출금:'Оноо татах',
        포인트입금:'Хадгаламжийн цэгүүд',
        바카라배팅:'баккара',
        바카라당첨:'баккара хожих',
        당첨금:'ялалт',
        배팅금:'мөрий',
        게임명:'тоглоомын нэр',
        공급사:'ханган нийлүүлэгч',
        부본총판매장:'Хуулбарлах-Дистрибьютор-Дэлгүүр',
        조회:'Хайх',
        이전잔액:'Өмнөх тэнцвэр',
        상위마스터:'дээд мастер',
        본사이름:'төв оффисын нэр',
        하위부본:'дэд хэсэг',
        본사아이디:'төв оффисын ID',
        체크타임:'шалгах цаг',
        상위:'ялгаа',
    },

 newAdd:{
  수정내용:'Өөрчлөгдсөн агуулга',
        수정시간:'Өөрчлөлтийн хугацаа',
        번호:'тоо',
        쪽지보내기:'Зурвас илгээх',
          월정산:'Волжонсан',
          월별종합현황:'Сарын иж бүрэн статус:',
          받은날짜:'Хүлээн авсан огноо',
          확인날짜:'Баталгаажуулах огноо',
          발신자:'Илгээгч',
          선택쪽지삭제:'Сонгосон мессежийг устгах',
        쪽지매크로관리:'Мессежийн макро удирдлага',
         EOS5파조합:'EOS5 долгионы хослол',
        EOS5파단폴:'EOS5  таслах туйл',
        EOS5일조합:'EOS5 өдрийн холбоо',
        스피드키노파조합:'Speed Kino Pa Combination',
        수정이력:'Засвар хийсэн түүх',
        머니:'Мөнгө',
        번호앞에:'Тооны өмнө',
        일괄생성:'Багц үүсгэх',
        없음:'Аль нь ч',
        입력비번:'оруулах',
        본사가보유한알잔액입니다:'Энэ бол төв оффисын үлдэгдэл:',
        하부회원은:'Дэд гишүүн',
        업데이트:'Шинэчлэлт',
        심리스:'Тохиолдолгүй',
        트랜스퍼:'шилжүүлэх',
        아너링크:' Honor Link',
        지값방식:'Газрын үнэлгээний арга',
        이미지:'зураг',
        게임이름:'Тоглоомын нэр',
        앱아이디:'Апп ID',
       루징:'Лужин',
        알충알환:'Алчунг/алхван',
        입금출금 :'Мэдээж оруулах/Татан авах ',
        전액을회수하시겠습니까:'Та мөнгөө бүрэн нөхөхийг хүсэж байна уу',
       실시간접속:'Бодит цагийн хандалт',
        수수료:'төлбөр',
        손익:'P&L',
        인증번호:'Баталгаажуулалтын дугаар',
        인증번호입력해주세요:'Гэрчилгээний дугаараа оруулна уу',
        슬롯다이아:'Slot Diamond',
        슬롯게이트:'Slotgate',
        취소하시겠습니까:'Та цуцлахыг хүсэж байна уу',
        쿠폰관리:'Доод гишүүн',
        본인:'би',
        하부회원:'Доод гишүүн',
        알머니:'Almoney',
        일반회원은가슬머니또는파워머니가능:'Ерөнхий гишүүд Гасулын мөнгө эсвэл Эрчим хүчний мөнгийг ашиглаж болно',
        파트너는알머니만가능합니다:'Түншүүд зөвхөн Алмонийг хүлээн авах боломжтой',
        알보유금:'Нөөц мөнгө',
        스페이더:'Spader',
        입금:'Хадгаламж',
        첫충:'Эхний цэнэглэлт',
        재충:'цэнэглэ',
         머니구분:'Мөнгөний ангилал',
        미사용:'ашиглагдаагүй',
        사용완료:'Ашигласан',
        만기:'төлөвшил',
        사용시간:'ашиглалтын хугацаа',
        날짜선택:'Огноо сонгох',
        비고:'тэмдэглэл',
        만기일:'дуусах хугацаа',
        쿠폰금액:'Купоны хэмжээ',
        사용조건:'Хэрэглэх нөхцөл',
        쿠폰유형:'Купон төрөл',
        가입쿠폰:'Бүртгүүлэх купон',
        이벤트쿠폰:'үйл явдлын купон',
        감사쿠폰:'баярлалаа купон',
        등급업쿠폰:'Ангилах купон',
        기타:'гэх мэт',
        게임사충환:'Тоглоомын хог хаягдлын агнуур',
        슬루징:'Лааглах',
        파루징:'Парус хийх',
        카루징:'дурлах',
        카베팅당첨차액:'Машины бооцоо тавих/Хожих/Ялгаа/Өнхрөх',
        슬베팅당첨차액:'Сул бооцоо / ялалт / ялгаа / өнхрөх',
        파베팅당첨차액:'Пар бооцоо / ялалт / ялгаа / гулсмал',
        슬정산:'Сүлжонсан уул',
        파정산:'Пажонсан уул',
        카정산:'Кажонсан уул',
        보유롤링:'гулсмал барих',
        다운하시겠습니까:'Та татаж авахыг хүсч байна уу?',
        변경하시겠습니까:'Өөрчилмөөр байна уу?',
        다운:'доош',
        API밴드사:'API Band компани',
        API주소:'API хаяг',
        사이트이름:'Сайтын нэр',
        매장총판업:'Дэлгүүр -> Дистрибьютор',
        매장총판등급업니다:'Дэлгүүр -> Дистрибьютороос эрэмбэлсэн',
        매장아이디:'Дэлгүүрийн ID',
        변경:'өөрчлөх',
        선택리턴하시겠습니까:'Сонголтыг буцаахыг хүсэж байна уу?',
        선택리턴:'Буцааж сонгоно уу',
        방어하시면한국아이피만허용되며방어시스템이작동됩니다:'Хамгаалалт асаалттай үед зөвхөн Солонгосын IP хаягийг зөвшөөрч хамгаалалтын систем идэвхждэг.',
        영어이름:'Англи нэр',
        루징머니:'Мөнгө алдах',
        업체이름:'Компанийн нэр',
        업체아이디:'Компанийн ID',
        수수료요율:'Төлбөрийн хувь хэмжээ',
        업체비번:'Компанийн нууц үг',
        정산합계:'Төлбөрийн нийт',
        쿠폰:'купон',
        게임사:'тоглоомын компани',
        회원가입순:'Гишүүнчлэлийн бүртгэлийн дараалал',
        게임:'тоглоом',
    },
}
   



// WEBPACK FOOTER //
// ./src/vueI18n/mg.js